import { useHistory } from "react-router-dom"
import { Container } from "src/components/container"
import { Image } from "src/components/Image"
import { Button } from "src/components/ui/button"
import { ChevronRight } from "src/icons"
import "./style.scss"

export const Empowering = () => {
  const history = useHistory()
  return (
    <div style={{ position: "relative", width: "100%", overflow: "hidden" }} className="empowering-section">
      <div style={{ overflow: "unset" }}>
        <div style={{ position: "absolute", inset: 0, zIndex: 90 }}>
          <video autoPlay loop muted playsInline poster="img/bg.jpg" style={{ objectFit: "cover", height: "100%", width: "100%" }}>
            <source src="/img/video_bg.mp4" type="video/mp4" />
          </video>
        </div>
      </div>
      <Container className="empowering-content">
        <h1>Empowering People to Rethink Banking</h1>
        <p>
          7Gates inspires businesses with crypto-friendly solutions — featuring dedicated IBANs, global transfers, and
          seamless crypto-to-fiat integration, trusted by people shaping the future.
        </p>
        <Button onClick={() => history.push("/register/corporate")} rightIcon={<ChevronRight />}>
          TRY 7GATES
        </Button>
        <Image src="iban/hero-phone-2.png" width={331} style={{ marginTop: 31 }} />
      </Container>
      <div className="emoji star-eye">🤩</div>
      <div className="emoji emoji-square smile">😊</div>
      <div className="emoji sunglass">😎</div>
      <div className="emoji emoji-square grin">😁</div>
    </div>
  )
}
